import { useEffect, useState } from "react";
import { X, Share, PlusSquare } from "lucide-react";
import { useCart } from "../context/CartContext";

export const InstallNudge = () => {
  const { count } = useCart();
  const [show, setShow] = useState(false);
  const [deferred, setDeferred] = useState(null);
  const [ios, setIos] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("tw_install_done")) return;
    if (window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone) return;
    if (!window.matchMedia("(max-width: 768px)").matches) return;
    let visits = parseInt(localStorage.getItem("tw_visits") || "0", 10);
    if (!sessionStorage.getItem("tw_visited")) {
      sessionStorage.setItem("tw_visited", "1");
      visits += 1;
      localStorage.setItem("tw_visits", String(visits));
    }
    if (visits < 2) return;
    const isIos = /iphone|ipad|ipod/i.test(navigator.userAgent);
    setIos(isIos);
    const onBip = (e) => { e.preventDefault(); setDeferred(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", onBip);
    let t;
    if (isIos) t = setTimeout(() => setShow(true), 2000);
    return () => { window.removeEventListener("beforeinstallprompt", onBip); if (t) clearTimeout(t); };
  }, []);

  const dismiss = () => { localStorage.setItem("tw_install_done", "1"); setShow(false); };
  const install = async () => {
    if (deferred) { deferred.prompt(); await deferred.userChoice.catch(() => {}); }
    dismiss();
  };

  if (!show) return null;
  return (
    <div data-testid="install-nudge" className={`fixed ${count > 0 ? "bottom-24" : "bottom-4"} inset-x-4 z-[55] md:hidden bg-[#171715] text-[#FBF6F1] p-4 shadow-xl flex items-start gap-3`}>
      <img src="/icon-192.png" alt="" className="h-10 w-10 shrink-0" />
      <div className="flex-1 min-w-0 text-sm">
        <p className="font-medium">Add tiff. to your home screen</p>
        {ios ? (
          <p className="text-xs text-[#FBF6F1]/70 mt-1 flex items-center gap-1 flex-wrap">
            Tap <Share size={14} className="inline" /> Share, then <PlusSquare size={14} className="inline" /> "Add to Home Screen"
          </p>
        ) : (
          <p className="text-xs text-[#FBF6F1]/70 mt-1">Reorder your stack in one tap, right from your phone.</p>
        )}
        {!ios && (
          <button data-testid="install-nudge-install-button" className="bg-[#FBF6F1] text-[#171715] px-4 min-h-[40px] font-semibold text-sm mt-2" onClick={install}>Install</button>
        )}
      </div>
      <button data-testid="install-nudge-dismiss-button" aria-label="Dismiss" className="min-h-[44px] min-w-[44px] flex items-center justify-center shrink-0" onClick={dismiss}><X size={18} /></button>
    </div>
  );
};
